import React, { useState, useEffect, useRef } from 'react';
import FormularioMateriaPrima from './FormularioMateriaPrima';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';
import { ehPrincipal } from '../utils/responsavelPrincipal';
import PopupNovaPessoa from '../components/PopupNovaPessoa';
import { useClienteDaProducao } from '../utils/clienteDaProducao';

function FormularioManutencao({
	onSubmit, // callback para notificar parent (recebe dados criados)
	onCancel,
	responsaveis = [], // lista de pessoas disponíveis (prop nome confusa, vem de ManutencaoDropdown as `pessoas`)
	producaoSelecionada = null,
	modoEdicao = false,
	dadosEdicao = null,
	dataPreSelecionada = '', // data (YYYY-MM-DD) escolhida previamente no calendário, para pré-preencher a Data Execução
	onCriarResponsavel, // função para abrir modal criar pessoa
	responsaveisManutencao = [], // lista de responsáveis vinculados (modo edição)
	onAdicionarResponsavel, // handler to add a vinculo (will usually open add-resp UI)
	onRemoverResponsavel, // handler to remove a vinculo
	onDefinirPrincipal, // marca/desmarca o responsável principal (edição)
	onPessoaCriada, // depois de "Adicionar nova pessoa": a tela recarrega a lista de pessoas
	refFormularioMateriaPrima
}) {
	const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState({
		producoesId: producaoSelecionada ? (producaoSelecionada.producaoId || producaoSelecionada.ProducaoId) : '',
		id_cliente: producaoSelecionada ? (producaoSelecionada.clienteId || producaoSelecionada.ClienteId) : '',
		descricao: '',
		dataExecucao: dataPreSelecionada || '',
		custo: '',
		responsavel: '',
		pessoaId: '',
		status: 'Pendente'
	});

	// Cliente vem da produção (não é editável)
	useClienteDaProducao(formData.producoesId, clienteId => setFormData(prev => ({ ...prev, id_cliente: clienteId })));

	// Responsáveis que o usuário adiciona na criação: array de pessoaId strings
	const [responsaveisSelecionados, setResponsaveisSelecionados] = useState(['']);
	// Dados por responsável: { horasPrevistas, horasReais }
	const [responsaveisDados, setResponsaveisDados] = useState([{}]);
	// "Adicionar nova pessoa": cria sem sair da tela e já seleciona a pessoa numa linha vazia
	const [novaPessoaAberta, setNovaPessoaAberta] = useState(false);
	const aoCriarPessoa = async (criada) => {
		if (onPessoaCriada) await onPessoaCriada();
		const id = criada?.id ?? criada?.Id;
		if (!id) return;
		const vazia = responsaveisSelecionados.findIndex(r => !r);
		if (vazia >= 0) {
			setResponsaveisSelecionados(responsaveisSelecionados.map((r, i) => (i === vazia ? String(id) : r)));
		} else {
			setResponsaveisSelecionados([...responsaveisSelecionados, String(id)]);
			setResponsaveisDados([...responsaveisDados, {}]);
		}
	};
	// Linha marcada como responsável principal na criação (opcional; só uma)
	const [principalIndex, setPrincipalIndex] = useState(null);
	// Mostra (toggle) Matérias-Primas alocadas delegadas ao FormularioMateriaPrima
	const [showMaterias, setShowMaterias] = useState(false);

	// Base URLs para API
	const BASE_URLS_MANUT = [
		`${BASE_URL}/Manutencao`,
		`${BASE_URL}/Manutencao`,
		'/api/Manutencao'
	];
	const BASE_URLS_RESP = [
		`${BASE_URL}/Responsaveis`,
		`${BASE_URL}/Responsaveis`,
		'/api/Responsaveis'
	];
	const BASE_URLS_PESSOAS = [
		`${BASE_URL}/Pessoas`,
		`${BASE_URL}/Pessoas`,
		'/api/Pessoas'
	];
	// BASE_URLS_HORAS removido - horas agora são incluídas no modelo Responsaveis

	// Helper: tenta uma lista de baseUrls, com endpoint opcional
	const apiCall = async (bases, endpoint = '', method = 'GET', data = null) => {
		let lastErr = null;
		for (const base of bases) {
			try {
				const url = endpoint ? `${base}/${endpoint}` : base;
				const cfg = { method, headers: { 'Content-Type': 'application/json' } };
				const token = getAuthToken();
				if (token) cfg.headers['Authorization'] = 'Bearer ' + token;
				if (data && method !== 'GET') cfg.body = JSON.stringify(data);
				const res = await fetch(url, cfg);
				if (!res.ok) throw new Error(`HTTP ${res.status}`);
				// Some endpoints (DELETE) may return empty body
				const text = await res.text();
				try {
					return text ? JSON.parse(text) : null;
				} catch (e) {
					return null;
				}
			} catch (err) {
				lastErr = err;
				continue;
			}
		}
		throw lastErr;
	};

	useEffect(() => {
		if (producaoSelecionada) {
			setFormData(prev => ({ ...prev, producoesId: producaoSelecionada.producaoId || producaoSelecionada.ProducaoId || '', id_cliente: producaoSelecionada.clienteId || producaoSelecionada.ClienteId || '' }));
		}
	}, [producaoSelecionada]);

	useEffect(() => {
		if (dataPreSelecionada && !modoEdicao) {
			setFormData(prev => ({ ...prev, dataExecucao: dataPreSelecionada }));
		}
	}, [dataPreSelecionada, modoEdicao]);

	useEffect(() => {
		if (modoEdicao && dadosEdicao) {
			setFormData({
				producoesId: dadosEdicao.producoesId || dadosEdicao.ProducoesId || '',
				id_cliente: dadosEdicao.id_cliente || dadosEdicao.Id_cliente || '',
				descricao: dadosEdicao.descricao || dadosEdicao.Descricao || '',
				dataExecucao: dadosEdicao.dataExecucao ? (dadosEdicao.dataExecucao.split && dadosEdicao.dataExecucao.split('T')[0]) : (dadosEdicao.DataExecucao ? dadosEdicao.DataExecucao.split('T')[0] : ''),
				custo: dadosEdicao.custo || dadosEdicao.Custo || '',
				responsavel: dadosEdicao.responsavel || dadosEdicao.Responsavel || '',
				pessoaId: dadosEdicao.pessoaId || dadosEdicao.PessoaId || '',
				status: dadosEdicao.status || dadosEdicao.Status || 'Pendente'
			});
			// Se houver responsáveis vinculados, preencha arrays
			if (dadosEdicao.responsaveis && Array.isArray(dadosEdicao.responsaveis)) {
				setResponsaveisSelecionados(dadosEdicao.responsaveis.map(r => String(r.pessoasId || r.PessoasId || r.pessoasid || r.Pessoasid || r.PessoasId || r.id || r.Id || '')));
				setResponsaveisDados(dadosEdicao.responsaveis.map(r => ({ horasPrevistas: r.horasPrevistas || r.HorasPrevistas || r.horasPrev || r.HorasPrev || '', horasReais: r.horasReais || r.HorasReais || r.horasReal || r.HorasReal || '' })));
			}

			// Em edição, o FormularioMateriaPrima fará o GET quando o bloco for aberto
		}
	}, [modoEdicao, dadosEdicao]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData(prev => ({ ...prev, [name]: value }));
	};

	const handleResponsavelChange = (index, value) => {
		const arr = [...responsaveisSelecionados];
		arr[index] = value;
		setResponsaveisSelecionados(arr);
	};

	const handleHorasChange = (index, field, value) => {
		const arr = [...responsaveisDados];
		if (!arr[index]) arr[index] = {};
		arr[index][field] = value;
		setResponsaveisDados(arr);
	};

	const adicionarResponsavel = () => {
		setResponsaveisSelecionados([...responsaveisSelecionados, '']);
		setResponsaveisDados([...responsaveisDados, {}]);
	};

	const removerResponsavel = (index) => {
		if (responsaveisSelecionados.length <= 1) return;
		setResponsaveisSelecionados(responsaveisSelecionados.filter((_, i) => i !== index));
		setResponsaveisDados(responsaveisDados.filter((_, i) => i !== index));
		// O principal acompanha a linha (se a removida era a principal, fica sem principal)
		setPrincipalIndex(p => (p === index || p == null ? null : (p > index ? p - 1 : p)));
	};

	// SUBMIT: cria manutenção, depois vincula responsáveis e registra horas
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (modoEdicao) {
			// Em modo edição, delega para o parent (evita duplicar lógica de update)
			if (onSubmit) onSubmit(formData);
			return;
		}

		setLoading(true);
		try {
			// 1) Criar manutenção
			const manutPayload = {
				ProducoesId: formData.producoesId ? parseInt(formData.producoesId) : null,
				Id_cliente: formData.id_cliente ? parseInt(formData.id_cliente) : null,
				Descricao: formData.descricao || '',
				DataExecucao: formData.dataExecucao || null,
				Custo: formData.custo ? parseFloat(formData.custo) : 0,
				Responsavel: formData.responsavel || '',
				PessoaId: formData.pessoaId ? parseInt(formData.pessoaId) : null,
				Status: formData.status || 'Pendente'
			};
			const criada = await apiCall(BASE_URLS_MANUT, '', 'POST', manutPayload);
			const manutencaoId = criada?.id || criada?.Id || criada?.ManutencaoId;

			// 2) Para cada responsável selecionado, criar vínculo com horas incluídas (novo modelo)
			for (let i = 0; i < responsaveisSelecionados.length; i++) {
				const pessoaId = responsaveisSelecionados[i];
				if (!pessoaId || !String(pessoaId).trim()) continue;

				const horasPrev = responsaveisDados[i]?.horasPrevistas ? parseFloat(responsaveisDados[i].horasPrevistas) : 0;
				const horasReal = responsaveisDados[i]?.horasReais ? parseFloat(responsaveisDados[i].horasReais) : 0;

				const payloadResp = {
					Id: 0,
					PessoasId: parseInt(pessoaId),
					ProducaoId: formData.producoesId ? parseInt(formData.producoesId) : null,
					ManutencaoId: manutencaoId,
					HorasPrevistas: horasPrev,
					HorasReais: horasReal,
					// Principal escolhido (com um só, o servidor já marca como principal)
					ResponsavelPrincipal: principalIndex === i
				};
				try {
					const respCriado = await apiCall(BASE_URLS_RESP, '', 'POST', payloadResp);
					console.log('✅ Responsável criado com horas incluídas:', respCriado);
				} catch (err) {
					console.warn('Falha ao criar vínculo de responsável:', err);
				}
			}

			alert('Manutenção e responsáveis criados com sucesso!');
			// Notifica parent com objeto criado (se quiser recarregar)
			if (onSubmit) onSubmit(criada);
			// Resetar formulário
			setFormData({ producoesId: '', id_cliente: '', descricao: '', dataExecucao: '', custo: '', responsavel: '', pessoaId: '', status: 'Pendente' });
			setResponsaveisSelecionados(['']);
			setResponsaveisDados([{}]);
			setPrincipalIndex(null);
		} catch (error) {
			console.error('Erro ao criar manutenção:', error);
			alert('Erro ao criar manutenção: ' + (error.message || error));
		} finally {
			setLoading(false);
		}
	};

	return (
		<form onSubmit={handleSubmit} className="formulario-manutencao-form">
			<div id="manutencao-form-dados" className="formulario-manutencao-grid">
				<div className="form-field">
					<label className="form-field-label">ID Projeto</label>
					<input name="producoesId" value={formData.producoesId} onChange={handleChange} type="number" className="form-field-input" />
				</div>
				<div className="form-field">
					<label className="form-field-label">ID Cliente</label>
					<input name="id_cliente" value={formData.id_cliente} readOnly title="O cliente vem do projeto" type="number" className="form-field-input" style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />
				</div>

				<div className="form-field">
					<label className="form-field-label">Data Execução</label>
					<input name="dataExecucao" value={formData.dataExecucao} onChange={handleChange} type="date" className="form-field-input" />
				</div>
				<div className="form-field">
					<label className="form-field-label">Custo (R$)</label>
					<input name="custo" value={formData.custo} onChange={handleChange} type="number" step="0.01" className="form-field-input" />
				</div>
				<div className="form-field">
					<label className="form-field-label">Status</label>
					{/* Ao mudar para Concluída e salvar, abre o pop-up das horas reais dos responsáveis */}
					<select name="status" value={formData.status || 'Pendente'} onChange={handleChange} className="form-field-input">
						<option value="Pendente">Pendente</option>
						<option value="Em Andamento">Em Andamento</option>
						<option value="Concluída">Concluída</option>
						<option value="Cancelada">Cancelada</option>
					</select>
				</div>

				<div className="form-field form-field-full">
					<label className="form-field-label">Descrição</label>
					<textarea name="descricao" value={formData.descricao} onChange={handleChange} rows={3} className="form-field-textarea" style={{ minHeight: 60 }} />
				</div>
			</div>

			{/* Responsáveis na criação (com horas previstas); na edição eles ficam em "Responsáveis Vinculados" */}
			{!modoEdicao && (
			<div id="manutencao-form-responsaveis" className="responsaveis-section-manutencao">
				<label className="responsaveis-header-manutencao">Responsáveis</label>
				<div className="responsaveis-list-manutencao">
				{responsaveisSelecionados.map((rid, idx) => (
					<div key={idx} className="responsavel-line-manutencao">
						<select value={rid} onChange={(e) => handleResponsavelChange(idx, e.target.value)} className="responsavel-select-manutencao">
							<option value="">Selecione uma pessoa</option>
							{responsaveis.map((p, i) => (
								<option key={p.id || p.Id || i} value={p.id || p.Id}>
									{p.nome || p.Nome}
								</option>
							))}
						</select>

						<input type="number" placeholder="Hrs previstas" value={responsaveisDados[idx]?.horasPrevistas || ''} onChange={e => handleHorasChange(idx, 'horasPrevistas', e.target.value)} className="responsavel-input-manutencao" title="Horas previstas (as reais são lançadas ao concluir a manutenção)" />

						{/* Com mais de um responsável, pode marcar um como principal (opcional; só um) */}
						{responsaveisSelecionados.filter(Boolean).length > 1 && rid && (
							<label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: principalIndex === idx ? 'rgb(235, 133, 0)' : '#555', cursor: 'pointer' }}>
								<input type="checkbox" checked={principalIndex === idx} onChange={() => setPrincipalIndex(principalIndex === idx ? null : idx)} />
								Principal
							</label>
						)}

						<div className="responsavel-actions-manutencao">
							<button type="button" onClick={adicionarResponsavel} className="btn-add-responsavel-manutencao">+</button>
							{responsaveisSelecionados.length > 1 && (
								<button type="button" onClick={() => removerResponsavel(idx)} className="btn-remove-responsavel-manutencao">×</button>
							)}

							{idx === 0 && (
								<button type="button" onClick={() => setNovaPessoaAberta(true)} className="btn-add-pessoa-manutencao">Adicionar nova pessoa</button>
							)}
						</div>
					</div>
				))}
				</div>
			</div>
			)}

			{/* Responsáveis Vinculados - SOMENTE EM MODO EDIÇÃO */}
			{modoEdicao && responsaveisManutencao && responsaveisManutencao.length > 0 && (
				<div id="manutencao-form-responsaveis-vinculados" style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
						<label style={{ fontWeight: '500', fontSize: '14px' }}>
							Responsáveis Vinculados
						</label>
						{onAdicionarResponsavel && (
							<button
								type="button"
								onClick={onAdicionarResponsavel}
								style={{
									padding: '6px 12px',
									backgroundColor: 'rgb(235, 133, 0)',
									color: 'white',
									border: 'none',
									borderRadius: '5px',
									cursor: 'pointer',
									fontSize: '12px',
									fontWeight: 600
								}}
							>
								+ Adicionar
							</button>
						)}
					</div>
					{responsaveisManutencao.map((resp, idx) => (
						<div key={idx} style={{
							padding: '10px',
							backgroundColor: 'white',
							borderRadius: '5px',
							marginBottom: '8px',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center'
						}}>
							<div>
								<div style={{ fontWeight: '500', fontSize: '14px', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
									{resp.nome || resp.Nome || resp.nomePessoa || resp.NomePessoa}
									{/* Responsável principal: só um por manutenção (com um só, ele já é o principal) */}
									{onDefinirPrincipal ? (
										<button
											type="button"
											onClick={() => onDefinirPrincipal(resp)}
											title={ehPrincipal(resp) ? 'Clique para deixar de ser o principal' : 'Tornar este o responsável principal (só um)'}
											style={{ padding: '3px 10px', borderRadius: 12, border: '1px solid rgb(235, 133, 0)', cursor: 'pointer', fontSize: 11, fontWeight: 700, background: ehPrincipal(resp) ? 'rgb(235, 133, 0)' : '#fff', color: ehPrincipal(resp) ? '#fff' : 'rgb(235, 133, 0)' }}
										>
											{ehPrincipal(resp) ? '⭐ Principal' : '☆ Tornar principal'}
										</button>
									) : ehPrincipal(resp) && <span style={{ fontSize: 11, color: 'rgb(235, 133, 0)' }}>⭐ Principal</span>}
								</div>
							<div style={{ fontSize: '12px', color: '#666' }}>
								{(resp.custoHora || resp.CustoHora) ? `R$ ${(resp.custoHora || resp.CustoHora).toFixed(2)}/h` : ''}
								{(resp.horasPrevistas || resp.horasReais || resp.HorasPrevistas || resp.HorasReais) ? ` | Prev: ${resp.horasPrevistas || resp.HorasPrevistas || 0}h (bloqueado) / Real: ${resp.horasReais || resp.HorasReais || 0}h` : ''}
							</div>
							</div>
							{onRemoverResponsavel && (
								<button
									type="button"
									onClick={() => onRemoverResponsavel(resp)}
									style={{
										padding: '4px 8px',
										backgroundColor: '#f44336',
										color: 'white',
										border: 'none',
										borderRadius: '5px',
										cursor: 'pointer',
										fontSize: '12px'
									}}
								>
									Remover
								</button>
							)}
						</div>
					))}
				</div>
			)}

			{/* Container de Matérias-Primas (CRIAÇÃO e EDIÇÃO) */}
			{((!modoEdicao) || (modoEdicao && dadosEdicao)) && (
				<div id="manutencao-form-materias" style={{ marginTop: 20, padding: 15, backgroundColor: '#f9f9f9', borderRadius: 8, border: '1px solid #e0e0e0' }}>
					<h4 style={{ margin: '0 0 12px 0', color: 'rgb(235, 133, 0)', fontSize: 14 }}>Matérias-Primas</h4>
					<FormularioMateriaPrima 
						ref={refFormularioMateriaPrima}
						tarefaId={dadosEdicao?.id || dadosEdicao?.Id}
						tipoId="manutencao"
						onMateriaPrimaAdded={(result) => {
							console.log('✅ Matéria-prima adicionada:', result);
						}}
						modoEdicao={modoEdicao}
					/>
				</div>
			)}

			{/* Matérias-Primas - toggle to show FormularioMateriaPrima (delegates data fetching) */}
			{modoEdicao && dadosEdicao && (
				<div style={{ marginTop: 20 }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
						<div>
							{/* botão 'Ver Matérias-Primas Alocadas' removido conforme solicitado */}
							{showMaterias && (
								<button
									onClick={() => setShowMaterias(false)}
									style={{ padding: '8px 12px', backgroundColor: '#9e9e9e', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}
								>
									Fechar
								</button>
							)}
						</div>
					</div>
					{showMaterias && (
						<div style={{ marginTop: 12, padding: 12, backgroundColor: '#f9f9f9', borderRadius: 8, border: '1px solid #e0e0e0' }}>
							<FormularioMateriaPrima
								ref={refFormularioMateriaPrima}
								tarefaId={dadosEdicao.id || dadosEdicao.Id}
								tipoId="manutencao"
								modoEdicao={modoEdicao}
								onMateriaPrimaAdded={() => { /* optionally refresh */ }}
							/>
						</div>
					)}
				</div>
			)}

			<div className="form-buttons-container-manutencao">
				<button type="submit" disabled={loading} className="btn-salvar-manutencao">
					{modoEdicao ? 'Atualizar' : (loading ? 'Salvando...' : 'Salvar')}
				</button>
				<button type="button" onClick={onCancel} className="btn-cancelar-manutencao">Cancelar</button>
			</div>
			{novaPessoaAberta && (
				<PopupNovaPessoa onFechar={() => setNovaPessoaAberta(false)} onCriada={aoCriarPessoa} />
			)}
		</form>
	);
}

export default FormularioManutencao;

